import { ElementType, ReactNode } from "react";
import { ColorProps } from "styled-system";

import Box from "../Box/Box";
import { BoxProps } from "../Box/box.type";

export interface ResponsiveLayoutProps extends BoxProps {
  children: ReactNode;
  color?: ColorProps["color"];
  as?: ElementType;
}

export default function ResponsiveLayout({
  children,
  ...props
}: ResponsiveLayoutProps) {
  return (
    <Box
      width="100%"
      mx="auto"
      maxWidth="maxGridWidth"
      px={{
        mobile: "mobileGridMargin",
        tablet: "mobileGridMargin",
        desktop: "desktopGridMargin",
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
